import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const IoMdSearch = require("react-icons/io").IoMdSearch;

const ProdukAffiliate = () => {
  const [produkList, setProdukList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");
  const [typingTimeout, setTypingTimeout] = useState<any>(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [affiliateLink, setAffiliateLink] = useState("");

  const token = Cookies.get("token");

  const fetchProduk = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/produk`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { search },
      });

      setProdukList(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProduk();
  }, []);

  const handleSearchChange = (e: any) => {
    const value = e.target.value;
    setSearch(value);

    if (typingTimeout) clearTimeout(typingTimeout);

    const timeout = setTimeout(() => {
      fetchProduk();
    }, 500);

    setTypingTimeout(timeout);
  };

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("id-ID").format(price);
  };

  const calculateFinalPrice = (price: number, discount: number) => {
    if (!discount) return price;
    return price - price * (discount / 100);
  };

  const calculateCommission = (finalPrice: number, commissionPercent: number) => {
    return finalPrice * (commissionPercent / 100);
  };

  const openAffiliateModal = (product: any) => {
    setSelectedProduct(product);
    setAffiliateLink("");
    setShowModal(true);
  };

  const generateLink = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/affiliate/generate-link/${selectedProduct.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setAffiliateLink(res.data.link);
    } catch (err) {
      console.error(err);
    }
  };

  const copyLink = () => {
    navigator.clipboard.writeText(affiliateLink);
    alert("Link berhasil dicopy!");
  };

  return (
    <div className="mt-7">
      {/* HEADER */}

      <div className="flex justify-between mb-6">
        <h2 className="text-xl font-bold">Link Produk Affiliate </h2>

        <div className="flex border rounded-lg overflow-hidden">
          <input type="text" placeholder="Cari produk..." value={search} onChange={handleSearchChange} className="px-3 py-2 outline-none" />
          <button className="bg-yellow-500 text-white px-4">
            <IoMdSearch />
          </button>
        </div>
      </div>

      {/* GRID CARD */}

      {loading ? (
        <div className="flex justify-center py-20">
          <div className="animate-spin h-10 w-10 border-t-4 border-yellow-500 rounded-full"></div>
        </div>
      ) : (
        <div className="grid md:grid-cols-4 gap-6">
          {produkList.map((item: any) => {
            const finalPrice = calculateFinalPrice(item.price, item.discount);

            const commission = calculateCommission(finalPrice, item.commission_percent);

            return (
              <div key={item.id} className="bg-white border rounded-xl shadow hover:shadow-lg transition overflow-hidden">
                <img src={`${process.env.REACT_APP_STORAGE_URL}/products/${item.images?.[0]?.image}`} className="w-full h-52 object-cover" alt="" />

                <div className="p-4 space-y-2">
                  <h3 className="font-semibold">{item.name}</h3>

                  {item.discount ? <span className="text-xs bg-red-100 text-red-600 px-2 py-1 rounded">Diskon {item.discount}%</span> : null}

                  <p className="text-gray-500 text-sm">Harga : Rp {formatPrice(item.price)}</p>

                  <p className="font-semibold text-green-600">Final Price : Rp {formatPrice(finalPrice)}</p>

                  <p className="text-sm text-blue-600">
                    Komisi ({item.commission_percent}%) : Rp {formatPrice(commission)}
                  </p>

                  <button onClick={() => openAffiliateModal(item)} className="w-full mt-3 bg-black text-white py-2 rounded-lg hover:opacity-90">
                    Link Affiliate
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* MODAL */}

      {showModal && (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 ">
          <div className="bg-white rounded-xl p-6 w-[420px] space-y-4 mx-4">
            <h3 className="text-lg font-bold">Program Affiliate</h3>

            <p className="text-sm text-gray-600">Bagikan link affiliate produk ini ke teman, followers, atau customer Anda. Setiap pembelian melalui link ini Anda akan mendapatkan komisi.</p>

            {!affiliateLink ? (
              <button onClick={generateLink} className="w-full bg-yellow-500 text-white py-2 rounded-lg">
                GENERATE LINK
              </button>
            ) : (
              <div className="space-y-3">
                <input value={affiliateLink} readOnly className="w-full border rounded-lg px-3 py-2" />

                <button onClick={copyLink} className="w-full bg-green-500 text-white py-2 rounded-lg">
                  COPY LINK
                </button>
              </div>
            )}

            <button onClick={() => setShowModal(false)} className="w-full  text-sm bg-red-800 text-white py-2 rounded-lg">
              Tutup
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProdukAffiliate;
